import aryanImg from '../assets/Aryan Kumar.jpeg';
import krishImg from '../assets/Krish Mehta.png';
import purvikaImg from '../assets/Purvika.jpg';
import chinmayImg from '../assets/Chinmay Vasisht.jpeg';

export const CAROUSEL_REVIEWS = [
  {
    img: aryanImg,
    quote: "I studied my Grade 11th and Grade 12th from DPS Gachibowli, Hyderabad. My passion is in computer science and always wanted to do bachelor's at the top universities in the US. EDUTECHEX Ivy League Prep helped me a lot during the preparation for SAT, APs and university application procedure. I am grateful for the excellent support from EDUTECHEX!",
    name: 'Aryan Kumar',
    grade: 'Grade 12th',
    uni: 'Cornell & Case Western',
  },
  {
    img: krishImg,
    quote: "Studying bachelor's in electrical engineering at the top universities in the US is my dream. Through EDUTECHEX Ivy league program, I was able to successfully prepare for my abroad applications and got admissions in my dream colleges along with scholarships. Thanks for the excellent training and guidance received from EDUTECHEX counsellors.",
    name: 'Krish Mehta',
    grade: 'Grade 12th',
    uni: 'Stony Brook, Texas A&M',
  },
  {
    img: purvikaImg,
    quote: "EDUTECHEX Ivy League Program has helped me immensely through the entire US application process. I thank EDUTECHEX teachers and counsellors for the outstanding support for SAT, APs and University Placements Program. Thanks, EDUTECHEX for making my dream come true.",
    name: 'Purvika Reddy',
    grade: 'Grade 12th',
    uni: 'Dennison & ASU',
  },
  {
    img: chinmayImg,
    quote: "I studied my Grade 11th and 12th at Delhi Public School, Bangalore South. I came across EDUTECHEX through a counselling session and then later got enrolled into their Ivy League Program. The entire experience was excellent, I got training for SAT, APs and was able to do Internship from Columbia University. I highly recommend EDUTECHEX programs.",
    name: 'Chinmay Vasisht',
    grade: 'Grade 12th',
    uni: 'Stony Brook University',
  },
];